import React from "react";

import styles from "./Button.module.css";

export interface ButtonProps {
  /**
   * Button contents
   */
  children: React.ReactNode;
  /**
   * Optional click handler
   */
  onClick?: () => void;
  /**
   * Button variant
   */
  variant?: "primary" | "secondary" | "text";
  /**
   * Button size
   */
  size?: "sm" | "lg";
  /**
   * Button color
   */
  color?: "black";
  /**
   * Is the button disabled?
   */
  disabled?: boolean;
  /**
   * Button type
   */
  type?: "button" | "submit" | "reset";
  /**
   * Is the button full width?
   */
  isFullWidth?: boolean;
}

export const Button = ({
  children,
  onClick,
  variant = "primary",
  size = "lg",
  color = "black",
  disabled = false,
  type = "button",
  isFullWidth = false,
}: ButtonProps): JSX.Element => {
  const buttonClasses = [
    styles.button,
    styles[variant],
    styles[size],
    styles[color],
    disabled ? styles.disabled : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      className={buttonClasses}
      onClick={onClick}
      data-type={variant}
      disabled={disabled}
      type={type}
      style={{ width: isFullWidth ? "100%" : "auto" }}
    >
      {children}
    </button>
  );
};
